// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion--iqs2m"};